<template>
  <div class="gallery-page">

    <div class="gallery-grid">
      <div
        class="gallery-item"
        v-for="(img, index) in images"
        :key="index"
        @click="openModal(img.src, img.alt || `Slika ${index + 1}`)"
      >
        <img
          :src="img.src"
          :alt="img.alt || `Slika ${index + 1}`"
          class="gallery-img"
          loading="lazy"
        />
      </div>
    </div>

    <!-- Modal -->
    <div v-if="modalOpen" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <button class="modal-close" @click="closeModal">×</button>
        <img :src="modalImgSrc" :alt="modalImgAlt" class="modal-img" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useHead } from '@vueuse/head'   // <-- change here

const { t } = useI18n()

useHead({
  title: t('meta.galleryPageTitle'),
  meta: [
    {
      name: 'description',
      content: t('meta.galleryPageDescription')
    }
  ]
})

const images = []
for (let i = 1; i <= 37; i++) {
  images.push({ src: `/images/photo${i}.jpeg` })
}

const modalOpen = ref(false)
const modalImgSrc = ref('')
const modalImgAlt = ref('')

function openModal(src, alt) {
  modalImgSrc.value = src
  modalImgAlt.value = alt
  modalOpen.value = true
}

function closeModal() {
  modalOpen.value = false
  modalImgSrc.value = ''
  modalImgAlt.value = ''
}
</script>


<style scoped>
.gallery-page {
  text-align: center;
  padding: 40px 20px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.gallery-item {
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s ease;
}

.gallery-img:hover {
  transform: scale(1.03);
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.modal-img {
  max-width: 90vw;   
  max-height: 85vh;  
  width: auto;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}


.modal-close {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #fff;
  border: none;
  font-size: 24px;
  line-height: 1;
  padding: 5px 10px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
</style>
